import { useTranslation } from "react-i18next";
import { IoIosArrowDown } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import ItemsCount from "../../../../components/ItemsCount/ItemsCount";

interface Props {
  toggleFilter: boolean;
  setToggleFilter: any;
  report: any;
  reportAnswers: any[];
  reportAnswersFlow: any[];
  toggleOptions: any;
  setToggleOptions: any;
  filterValues: any;
  setFilterValues: any;
}

const DateFilter = ({ toggleFilter, setToggleFilter, report, reportAnswers, reportAnswersFlow, toggleOptions, setToggleOptions, filterValues, setFilterValues }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={`fixed top-0 bg-white h-full duration-300 z-[100] p-8 !pt-44 flex flex-col gap-4 shadow-2xl ${
        toggleFilter ? "end-0 w-[20vw]" : "-end-96 w-0"
      } toggleFilter`}
      onClick={(e) => e.stopPropagation()}
    >
      <h2 className="text-3xl font-bold relative mb-10">
        {t("filter_options")}
        <IoClose
          className="text-3xl cursor-pointer absolute top-1 end-5"
          onClick={() => setToggleFilter(false)}
        />
      </h2>
      {report?.report_type === "follow_up" ||
        (report?.report_type === "two_ways" &&
          (reportAnswers.length !== 0 || reportAnswersFlow.length !== 0) && (
            <>
              <span
                className={`flex items-center justify-between cursor-pointer text-2xl`}
                onClick={() =>
                  setToggleOptions({
                    ...toggleOptions,
                    stages: !toggleOptions.stages,
                  })
                }
              >
                {t("stages")}
                <IoIosArrowDown
                  className={`duration-300 ${
                    toggleOptions.stages && "rotate-180"
                  }`}
                />
              </span>
              <div
                className={`${
                  !toggleOptions.stages && "h-0 overflow-x-hidden"
                } flex flex-col gap-2 duration-300`}
              >
                <div className="flex items-center gap-2">
                  <div className="dark:bg-black/10 cursor-pointer">
                    <label className="text-white">
                      <input
                        className="dark:border-white-400/20 dark:scale-100 transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-5 h-5 cursor-pointer"
                        type="checkbox"
                        name="Opened"
                        id="Opened"
                        checked={filterValues.stages.includes("Opened")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFilterValues({
                              ...filterValues,
                              stages: [...filterValues.stages, "Opened"],
                            });
                          } else {
                            setFilterValues({
                              ...filterValues,
                              stages: filterValues.stages.filter(
                                (stage: any) => stage !== "Opened"
                              ),
                            });
                          }
                        }}
                      />
                    </label>
                  </div>
                  <label htmlFor="Opened" className="ml-2 cursor-pointer">
                    {t("opened")}
                  </label>
                </div>
                {report.report_type === "follow_up" && (
                  <div className="flex items-center gap-2">
                    <div className="dark:bg-black/10 cursor-pointer">
                      <label className="text-white">
                        <input
                          className="dark:border-white-400/20 dark:scale-100 transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-5 h-5 cursor-pointer"
                          type="checkbox"
                          name="Action"
                          id="Action"
                          checked={filterValues.stages.includes("Action")}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setFilterValues({
                                ...filterValues,
                                stages: [...filterValues.stages, "Action"],
                              });
                            } else {
                              setFilterValues({
                                ...filterValues,
                                stages: filterValues.stages.filter(
                                  (stage: any) => stage !== "Action"
                                ),
                              });
                            }
                          }}
                        />
                      </label>
                    </div>
                    <label htmlFor="Action" className="ml-2 cursor-pointer">
                      {t("action")}
                    </label>
                  </div>
                )}
                <div className="flex items-center gap-2">
                  <div className="dark:bg-black/10 cursor-pointer">
                    <label className="text-white">
                      <input
                        className="dark:border-white-400/20 dark:scale-100 transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-5 h-5 cursor-pointer"
                        type="checkbox"
                        name="Closed"
                        id="Closed"
                        checked={filterValues.stages.includes("Closed")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFilterValues({
                              ...filterValues,
                              stages: [...filterValues.stages, "Closed"],
                            });
                          } else {
                            setFilterValues({
                              ...filterValues,
                              stages: filterValues.stages.filter(
                                (stage: any) => stage !== "Closed"
                              ),
                            });
                          }
                        }}
                      />
                    </label>
                  </div>
                  <label htmlFor="Closed" className="ml-2 cursor-pointer">
                    {t("closed")}
                  </label>
                </div>
              </div>
            </>
          ))}
      <span
        className={`flex items-center justify-between cursor-pointer text-2xl`}
        onClick={() =>
          setToggleOptions({
            ...toggleOptions,
            date: !toggleOptions.date,
          })
        }
      >
        {t("date")}
        <IoIosArrowDown
          className={`duration-300 ${toggleOptions.date && "rotate-180"}`}
        />
      </span>
      <div
        className={`flex flex-col gap-4 duration-300 ${
          !toggleOptions.date && "h-0 overflow-x-hidden"
        }`}
      >
        <div className="flex flex-col gap-1">
          <label className="">{t("from")}:</label>
          <input
            type="datetime-local"
            className="w-fit border-solid border-4"
            onChange={(e) => {
              setFilterValues({
                ...filterValues,
                startDate: e.target.value,
              });
            }}
            name="startDate"
            value={filterValues.startDate}
            key={"startDate" + report?.report_title}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="">{t("to")}:</label>
          <input
            type="datetime-local"
            className="w-fit border-solid border-4"
            onChange={(e) => {
              setFilterValues({
                ...filterValues,
                endDate: e.target.value,
              });
            }}
            name="endDate"
            value={filterValues.endDate}
            key={"endDate" + report?.report_title}
          />
        </div>
      </div>
      <span
        className={`flex items-center justify-between cursor-pointer text-2xl`}
        onClick={() =>
          setToggleOptions({
            ...toggleOptions,
            count: !toggleOptions.count,
          })
        }
      >
        {t("count")}
        <IoIosArrowDown
          className={`duration-300 ${toggleOptions.count && "rotate-180"}`}
        />
      </span>
      <div
        className={`flex flex-col gap-4 duration-300 ${
          !toggleOptions.count && "h-0 overflow-x-hidden"
        }`}
      >
        <div className="flex flex-col gap-1">
          {/* <label className="">{t("items_per_page")}:</label> */}
          <ItemsCount />
        </div>
      </div>
    </div>
  );
};

export default DateFilter;
